import React from 'react';

import { reduxHooks } from 'hooks';
import StructuredCourseSections from 'components/StructuredCourseSections';

/**
 * Structured course view for a direct (non-purchase-gated) category:
 * renders its sub-categories via the shared StructuredCourseSections.
 */
export const StructuredCourseView = () => {
  const { subCategories } = reduxHooks.useSelectedNavContent();
  return <StructuredCourseSections subCategories={subCategories} />;
};

export default StructuredCourseView;
